import { render, staticRenderFns } from "./Accueil.vue?vue&type=template&id=a4c2a078&scoped=true&"
import script from "./Accueil.vue?vue&type=script&lang=js&"
export * from "./Accueil.vue?vue&type=script&lang=js&"
import style0 from "./Accueil.vue?vue&type=style&index=0&id=a4c2a078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c2a078",
  null
  
)

export default component.exports